export class OneToNVerify {
  id!: string;
  processingTime!: number;
  user!: any;
}
